import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Calendar, Check, Loader2 } from "lucide-react";
import { getCalendarStatus, getCalendarLoginUrl } from "@/lib/api";

// Discreet, admin-only Google Calendar connect control (lives in the footer).
export default function CalendarConnect() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCalendarStatus()
      .then(setStatus)
      .catch(() => setStatus({ configured: false, connected: false }));
  }, []);

  const connect = async () => {
    setLoading(true);
    try {
      const url = await getCalendarLoginUrl();
      window.location.href = url;
    } catch (e) {
      toast.error("No se pudo iniciar la conexión con Google Calendar.");
      setLoading(false);
    }
  };

  if (!status || !status.configured) return null;

  if (status.connected) {
    return (
      <span
        className="inline-flex items-center gap-1.5 text-white/40"
        data-testid="calendar-connected"
      >
        <Check size={13} className="text-[#9C5A4B]" />
        Calendario conectado
      </span>
    );
  }

  return (
    <button
      onClick={connect}
      disabled={loading}
      data-testid="calendar-connect-btn"
      className="inline-flex items-center gap-1.5 text-white/50 hover:text-white transition-colors duration-300"
    >
      {loading ? <Loader2 size={13} className="animate-spin" /> : <Calendar size={13} />}
      Conectar Google Calendar
    </button>
  );
}
